import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";

// Public Pages
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import VerifyCertificate from "./pages/VerifyCertificate";

// Client Pages
import MyLearning from "./pages/MyLearning";
import Certificates from "./pages/Certificates";
import CertificateView from "./pages/CertificateView";
import LessonPlayer from "./pages/LessonPlayer";

// Admin Pages
import AdminDashboard from "./pages/AdminDashboard";
import AdminUsers from "./pages/AdminUsers";
import AdminCourses from "./pages/AdminCourses";
import AdminModules from "./pages/AdminModules";
import AdminReports from "./pages/AdminReports";
import AdminDomains from "./pages/AdminDomains";
import AdminActivityLog from "./pages/AdminActivityLog";
import AdminClients from "./pages/AdminClients";

// Client Admin Pages
import CompanyDashboard from "./pages/CompanyDashboard";
import CompanyUsers from "./pages/CompanyUsers";
import CompanyReports from "./pages/CompanyReports";

import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:courseId" element={<CourseDetail />} />
          <Route path="/verify/:code" element={<VerifyCertificate />} />

          {/* Protected Client Routes */}
          <Route 
            path="/my-learning" 
            element={
              <ProtectedRoute>
                <MyLearning />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/certificates" 
            element={
              <ProtectedRoute>
                <Certificates />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/certificates/:certificateId" 
            element={
              <ProtectedRoute>
                <CertificateView />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/learn/:courseId/:moduleId" 
            element={
              <ProtectedRoute>
                <LessonPlayer />
              </ProtectedRoute>
            } 
          />

          {/* Protected Admin Routes (Employee Only) */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/users" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminUsers />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/courses" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminCourses />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/courses/new" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminCourses />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/courses/:courseId/modules" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminModules />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/reports" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminReports />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/domains" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminDomains />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/clients" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminClients />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/activity" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminActivityLog />
              </ProtectedRoute>
            } 
          />

          {/* Client Admin Routes */}
          <Route path="/company" element={<ProtectedRoute requiredRole="client_admin"><CompanyDashboard /></ProtectedRoute>} />
          <Route path="/company/users" element={<ProtectedRoute requiredRole="client_admin"><CompanyUsers /></ProtectedRoute>} />
          <Route path="/company/reports" element={<ProtectedRoute requiredRole="client_admin"><CompanyReports /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  );
}

export default App;
